import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Toast } from "../../config/config";
import Skeleton from "react-loading-skeleton";
import "./pageStats.css";
import { Container, Table } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faDownload,
  faEye,
  faFilePdf,
  faFileWord,
  faFileExcel,
  faFileImage,
  faFilePowerpoint,
  faFileAlt,
  faFileCsv,
  faFile,
} from "@fortawesome/free-solid-svg-icons";

export default function PageStats({
  countAction,
  downloadCount,
  pdf,
  id,
  fileViewCount,
}) {
  const dispatch = useDispatch();
  const [fileInfo, setFileInfo] = useState({ name: "", size: "" });
  const getFileIcon = (ext) => {
    switch (ext.toLowerCase()) {
      case "pdf":
        return faFilePdf;
      case "doc":
      case "docx":
        return faFileWord;
      case "xls":
      case "xlsx":
        return faFileExcel;
      case "ppt":
      case "pptx":
        return faFilePowerpoint;
      case "jpg":
      case "jpeg":
      case "png":
      case "gif":
      case "webp":
        return faFileImage;
      case "txt":
      case "json":
      case "xml":
        return faFileAlt;
      case "csv":
        return faFileCsv;
      default:
        return faFile;
    }
  };
  useEffect(() => {
    if (pdf) {
      const baseName = pdf.split("/").pop();
      const nameWithoutExt = baseName.replace(/\.[^/.]+$/, "");
      const readableName = nameWithoutExt.includes("-")
        ? nameWithoutExt.split("-").slice(1).join("-")
        : nameWithoutExt;
      setFileInfo((prev) => ({
        ...prev,
        name: readableName || "Unknown",
      }));

      fetch(pdf, { method: "HEAD" })
        .then((res) => {
          const contentLength = res.headers.get("content-length");
          if (contentLength) {
            const sizeMB = (
              parseInt(contentLength, 10) /
              (1024 * 1024)
            ).toFixed(2);
            setFileInfo((prev) => ({ ...prev, size: `${sizeMB} MB` }));
          }
        })
        .catch(() => {
          setFileInfo((prev) => ({ ...prev, size: "Unknown" }));
        });
    }
  }, [pdf]);

  const previewFile = () => {
    countAction && dispatch(countAction(id, "fileview"));
    const ext = pdf.split(".").pop().toLowerCase();
    const supportedTypes = [
      "pdf",
      "txt",
      "csv",
      "json",
      "xml",
      "jpg",
      "jpeg",
      "png",
      "gif",
      "webp",
    ];
    const unsupported = ["doc", "docx", "xls", "xlsx", "ppt", "pptx"];

    if (supportedTypes.includes(ext)) {
      window.open(pdf, "_blank", "noopener,noreferrer");
    } else if (unsupported.includes(ext)) {
      const fileUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(pdf)}`;
      window.open(fileUrl, "_blank", "noopener,noreferrer");
    } else {
      Toast.fire({
        icon: "info",
        title: "Preview not available for this file type.",
      });
    }
  };

  return (
    <>
      {/* <section className="pdf-info" data-aos="fade-up">
        <Container>
          <Table responsive className="mb-0">
            <thead>
              <tr>
                <th>File name</th>
                <th>Type</th>
                <th>Size</th>
                <th>View</th>
                <th style={{ width: "85px" }}>Download</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>{fileInfo.name || <Skeleton width={80} />}</td>
                <td>
                  {pdf ? (
                    <>
                      <FontAwesomeIcon
                        icon={getFileIcon(pdf.split(".").pop())}
                        className="me-2"
                        fontSize={22}
                        color={"var(--theme-secondary)"}
                      />
                      {pdf.split(".").pop().toUpperCase()}
                    </>
                  ) : (
                    "..."
                  )}{" "}
                </td>
                <td>{fileInfo.size || <Skeleton width={50} />}</td>
                <td>
                  <button
                    className="view-button btn btn-sm btn-solid-blue d-flex gap-2"
                    onClick={previewFile}
                  >
                    <FontAwesomeIcon icon={faEye} />
                    {fileViewCount != null && `${fileViewCount}`}
                  </button>
                </td>
                <td>
                  <button
                    className="download-button btn btn-sm btn-solid-blue d-flex gap-2"
                    onClick={handleDownloadPdf}
                  >
                    <FontAwesomeIcon icon={faDownload} />
                    {downloadCount != null && `${downloadCount}`}
                  </button>
                </td>
              </tr>
            </tbody>
          </Table>
        </Container>
      </section> */}
    </>
  );
}
